import React, { useState, useEffect } from "react";
import LearnerTableViewSearch from "../../../CustomComponent/LearnerTableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Button, Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useLocation } from "react-router-dom";

function ViewLearner() {
  const classes = useStyles();


  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [learners, setLearners] = useState([]);


  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);

  const [rowCount, setRowCount] = useState("");

  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

   const [page, setPage] = useState(0);
  
        const handlePageChange = (newPage) => {
      setPage(newPage);
      setOnPage(newPage) // Pass newSelection directly
    };
  

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editlearners") {
      navigate(`/admin/editlearners/${rowId}`);
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );
  //     setLearners(response.data.learners);
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //   }
  // };

  // const fetchData = async ( onPage,  pageSize, searchQuery) => {
  //   setLoading(true);
  //   // console.log("➡️  calling API", { page: _page + 1, limit: _pageSize, search: _search });
  //   try {
  //     const { data } = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/pagination/learner?page=${onPage + 1}&limit=${pageSize}&search=${""}`,
  //       {
  //               headers: { Authorization: `Bearer ${decryptedToken}` }
  //       }
  //     );
  //     // console.log("response data-------", data);
  //     setLearners(data.learners);
  //     setRowCount(data.totalCount);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // console.log('pageSizepageSizepageSizepageSize123', pageSize, onPage);



  const fetchData = async (pageNumber, size, search) => {

      if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/pagination/learner?page=${pageNumber + 1}&limit=${size}&search=${search}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data;
        console.log('learnerslearnerslearners', data);

        setLearners(data.learners);
        setRowCount(data.totalCount);
      } else {
        // toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
    }
  };

  useEffect(() => {
    if (onPage !== undefined && pageSize !== undefined && searchQuery !== undefined) {
      fetchData(onPage, pageSize, searchQuery);
    }
  }, [onPage, pageSize , searchQuery]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      console.log("Learner deleted:", response.data);
      fetchData(onPage, pageSize , searchQuery);
      handleClose();
      toast.success("Learner deleted successfully");
      const updateddatatata = learners.filter((data) => data.id !== rowId);
      setLearners(updateddatatata);
    } catch (error) {
      toast.error("Learner is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      learner: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/status`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        console.log("Learner status changed successfully", response);
        fetchData(onPage, pageSize , searchQuery);
        toast.success("Learner status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Learner status:", error);
        toast.error("Learner status is not changed");
      });
  };
  
function convertToLocalDate(isoString) {

if(!isoString){
  return null
}

  const date = new Date(isoString);

  // Get local parts
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

  useEffect(() => {
  const startIndex = onPage * pageSize;

  const mappedRows = learners.map((d) => ({
    id: d.id || "N/A",
    full_name: d.full_name || "N/A",
    guardian_name: d.learner_information?.guardian_name || "N/A",
    phone: d.phone || "N/A",
    email: d.email || "N/A",
    DOB: convertToLocalDate(d?.learner_information?.dob) || 'N/A',
    course_name: d.learner_information?.course?.course_name || "N/A",
    batch_name: d.learner_information?.batch?.batch_name || "N/A",
    center_code: d.learner_information?.center
      ? `${d.learner_information.center.center_code || "N/A"} - ${d.learner_information.center.center_name || "N/A"}`
      : "N/A",
    roll_no: d.learner_information?.roll_number || "N/A",
    active_status: d.active_status || "N/A",
  }));

  const finalRows = mappedRows.map((row, index) => ({
    ...row,
    srno: startIndex + index + 1,
  }));

  setRows(finalRows);
}, [learners, searchQuery, onPage, pageSize]);


  console.log(rows);
  


  const handleSearch = (query) => {

    setSearchQuery(query);
  };

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "roll_no",
      headerName: "Roll No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "full_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "DOB",
      headerName: "Date Of Birth",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "phone",
    //   headerName: "Ph.No.",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 110,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "course_name",
      headerName: "Course",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "batch_name",
      headerName: "Batch",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      // type: "number",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      autoPageSize: false,
      renderHeader: () => <>Status</>,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editlearners", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      // inputlable: "Enter Name / ID*",
      inputplaceholder: "Search By Name or ID",
      exportimport: "yes",
      exportFileName: "Learner_data.csv",
      hideImportButton: "No",
    },

  ];
  const style = [
    {
      style: "viewtable",
      height: "maxh67",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode:"server" 
    },
  ];

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt0_5}`}
      >
        <LearnerTableViewSearch
          fetchData={fetchData}
          learner={true}
          decryptedToken={decryptedToken}
          Heading={Heading}
          onSearch={handleSearch}
        />
        {/* <TableView columns={columns} rows={filteredRows} Heading={style} /> */}
        <TableView
          columns={columns}
          rows={rows}
          Heading={style}
          page={page}
          // onPageChange={setOnPage}
        // onPageChange={setPage}
        // onPageSizeChange={setPageSize}
        />

      </div>
    </>
  );
}
export default ViewLearner;
